import {
  ColumnMappingConfig,
  TableRowDto,
} from '@asset-metrix/portal-gateway-client-js';

export function mapColumnData(
  columnMapping:
    | Partial<Record<string, Pick<ColumnMappingConfig, 'key'>>>
    | undefined,
  data: TableRowDto['data'] | undefined
): Record<string, string> {
  return Object.fromEntries(
    Object.entries(columnMapping ?? {})
      .map((mapping) => {
        const columnValue = data?.[mapping[0]];
        const mappedValue = ['string', 'number'].includes(typeof columnValue)
          ? `${columnValue}`
          : undefined;

        return [mapping[1]?.key, mappedValue] as const;
      })
      .filter(
        (mapping): mapping is [string, string] => mapping[1] !== undefined
      )
  );
}
